export const SET_HRMS17E_INDEX_DISP = 'SET_HRMS17E_INDEX_DISP'
export const GET_HRMS17E_INDEX_DISP = 'GET_HRMS17E_INDEX_DISP'
export const SET_HRMS17E_DETAIL1_DISP = 'SET_HRMS17E_DETAIL1_DISP'
export const GET_HRMS17E_DETAIL1_DISP = 'GET_HRMS17E_DETAIL1_DISP'
export const SET_HRMS17E_DETAIL2_DISP = 'SET_HRMS17E_DETAIL2_DISP'
export const GET_HRMS17E_DETAIL2_DISP = 'GET_HRMS17E_DETAIL2_DISP'
export const SET_HRMS17E_COLUMNS = 'SET_HRMS17E_COLUMNS'
export const GET_HRMS17E_COLUMNS = 'GET_HRMS17E_COLUMNS'
export const SET_HRMS17E_LABELS = 'SET_HRMS17E_LABELS'
export const GET_HRMS17E_LABELS = 'GET_HRMS17E_LABELS'
export const RECEIVED_HRMS17E_COLUMNS_LABELS = 'RECEIVED_HRMS17E_COLUMNS_LABELS'
export const GET_HRMS17E_MAX_ROWSPAN = 'GET_HRMS17E_MAX_ROWSPAN'
export const SET_HRMS17E_INDEX = 'SET_HRMS17E_INDEX'
export const GET_HRMS17E_INDEX = 'GET_HRMS17E_INDEX'
export const SET_HRMS17E_SEARCH_PARAMS_INDEX = 'SET_HRMS17E_SEARCH_PARAMS_INDEX'
export const GET_HRMS17E_SEARCH_PARAMS_INDEX = 'GET_HRMS17E_SEARCH_PARAMS_INDEX'
export const SET_HRMS17E_INDEX_SELECTED = 'SET_HRMS17E_INDEX_SELECTED'
export const GET_HRMS17E_INDEX_SELECTED = 'GET_HRMS17E_INDEX_SELECTED'
export const SET_HRMS17E_DETAIL1_SELECTED = 'SET_HRMS17E_DETAIL1_SELECTED'
export const GET_HRMS17E_DETAIL1_SELECTED = 'GET_HRMS17E_DETAIL1_SELECTED'
export const SET_HRMS17E_INLINE_DETAIL2_TAB1 = 'SET_HRMS17E_INLINE_DETAIL2_TAB1'
export const GET_HRMS17E_INLINE_DETAIL2_TAB1 = 'GET_HRMS17E_INLINE_DETAIL2_TAB1'
export const SET_HRMS17E_INLINE_DETAIL2_TAB2 = 'SET_HRMS17E_INLINE_DETAIL2_TAB2'
export const GET_HRMS17E_INLINE_DETAIL2_TAB2 = 'GET_HRMS17E_INLINE_DETAIL2_TAB2'
export const RECEIVED_HRMS17E_INDEX = 'RECEIVED_HRMS17E_INDEX'
export const RECEIVED_HRMS17E_CREATE = 'RECEIVED_HRMS17E_CREATE'
export const SET_HRMS17E_DETAIL = 'SET_HRMS17E_DETAIL'
export const GET_HRMS17E_DETAIL = 'GET_HRMS17E_DETAIL'
export const RECEIVED_HRMS17E_DETAIL = 'RECEIVED_HRMS17E_DETAIL'
export const TOGGLE_HRMS17E_PAGE = 'TOGGLE_HRMS17E_PAGE'
export const POST_HRMS17E_DELETE = 'POST_HRMS17E_DELETE'

export const GET_HRMS17E_DETAIL2 = 'GET_HRMS17E_DETAIL2'
export const SET_HRMS17E_DETAIL2 = 'SET_HRMS17E_DETAIL2'
export const RECEIVED_HRMS17E_DETAIL2_CREATE = 'RECEIVED_HRMS17E_DETAIL2_CREATE'
export const RECEIVED_HRMS17E_DETAIL2 = 'RECEIVED_HRMS17E_DETAIL2'
export const POST_HRMS17E_DETAIL1_TABLE_DELETE = 'POST_HRMS17E_DETAIL1_TABLE_DELETE'

export const SET_HRMS17E_CODEMPID = 'SET_HRMS17E_CODEMPID'
export const GET_HRMS17E_CODEMPID = 'GET_HRMS17E_CODEMPID'
export const RECEIVED_HRMS17E_CODEMPID = 'RECEIVED_HRMS17E_CODEMPID'
export const POST_HRMS17E_DETAIL2_SAVE = 'POST_HRMS17E_DETAIL2_SAVE'

export const GET_HRMS17E_DROPDOWNS = 'GET_HRMS17E_DROPDOWNS'
export const SET_HRMS17E_DROPDOWNS = 'SET_HRMS17E_DROPDOWNS'
export const RECEIVED_HRMS17E_DROPDOWNS = 'RECEIVED_HRMS17E_DROPDOWNS'

export const GET_HRMS17E_IMPORT = 'GET_HRMS17E_IMPORT'
export const SET_HRMS17E_IMPORT = 'SET_HRMS17E_IMPORT'
export const POST_HRMS17E_IMPORT = 'POST_HRMS17E_IMPORT'



// WEBPACK FOOTER //
// ./src/store/modules/hrms17e/mutation-types.js